import { css } from "@emotion/react"

export const fonts = css`
	@font-face {
		font-family: "Atlas Grotesk";
		src: url("/fonts/AtlasGrotesk-Black.woff2") format("woff2");
		font-weight: 900;
		font-style: normal;
		font-display: swap;
	}
	@font-face {
		font-family: "Atlas Grotesk";
		src: url("/fonts/AtlasGrotesk-Bold.woff2") format("woff2");
		font-weight: 700;
		font-style: normal;
		font-display: swap;
	}
	@font-face {
		font-family: "Atlas Grotesk";
		src: url("/fonts/AtlasGrotesk-Medium.woff2") format("woff2");
		font-weight: 500;
		font-style: normal;
		font-display: swap;
	}
	@font-face {
		font-family: "Atlas Grotesk";
		src: url("/fonts/AtlasGrotesk-Regular.woff2") format("woff2");
		font-weight: 400;
		font-style: normal;
		font-display: swap;
	}
	@font-face {
		font-family: "Atlas Grotesk";
		src: url("/fonts/AtlasGrotesk-Light.woff2") format("woff2");
		font-weight: 300;
		font-style: normal;
		font-display: swap;
	}
	@font-face {
		font-family: "Atlas Grotesk";
		src: url("/fonts/AtlasGrotesk-LightItalic.woff2") format("woff2");
		font-weight: 300;
		font-style: italic;
		font-display: swap;
	}
`
